import React, { useState, useEffect } from 'react';
import { Navigation } from '../navigation';
import { Link } from 'react-router-dom';
import SubVeg from './subveg'; // Import the SubProductView component

export const Vegetables = () => {
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [veg, setVeg] = useState([]);
  const [subProductsAvailable, setSubProductsAvailable] = useState(false); // Add a state to track sub-products availability

  useEffect(() => {
    // Fetch crop data from the backend API
    fetch(`${process.env.REACT_APP_BASE_URL}/vegetables/allvegs`)
      .then((response) => response.json())
      .then((data) => setVeg(data))
      .catch((error) => console.error('Error fetching vegetables data:', error));
  }, []);

  const handleMainProductClick = async (vegId) => {
    try {
      // Fetch sub-products for the selected main product from the backend API
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/subveg/${vegId}/subProducts`);
      const data = await response.json();

      if (data.length > 0) {
        setSelectedProductId(vegId);
        setSubProductsAvailable(true);
      } else {
        setSelectedProductId(null);
        setSubProductsAvailable(false);
      }
    } catch (error) {
      console.error('Error fetching sub-products:', error);
    }
  };

  return (
    <>
      <div className="border-b border-gray-300">
        <Navigation />
      </div>

      <nav className="pt-5 font-inter pb-10 sm:px-4 border-gray-300 text-4xl text-center">
        <span>Vegetables</span>
      </nav>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-10 px-8">
        {veg.map((veg) => (
          <div key={veg._id} className="hover:scale-105 cursor-pointer">
           <Link to={subProductsAvailable ? `/veg/${veg._id}/subveg` : ''} onClick={() => handleMainProductClick(veg._id)}>
              <article className={`overflow-hidden rounded-lg shadow-lg hover:shadow-xl ${selectedProductId === veg._id ? 'border-4 border-blue-500' : ''}`}>
                <img alt="veg" className="block h-56 w-full object-cover" src={veg.product_image} />
                <header className="flex items-center justify-between leading-tight p-1">
                  <h1 className="text-lg">
                    <a className="ml-4 text-xl font-medium text-black">
                      {veg.product_name}
                    </a>
                  </h1>
                </header>
              </article>
            </Link>
          </div>
        ))}
      </div>

      {selectedProductId !== null && <SubVeg selectedProductId={selectedProductId} />}

    </>
  );
};
